module.exports = {
  global: {
    ruleLabel: 'ច្បាប់',
    shareSuccess: "Share Successfully",
    shareFail: "Share Fail",
    moreButtonLabel: 'ច្រើនទៀត',
    goShopping: 'Go Buy',
    gameOver: 'Dear friends, the event is over!',
    moreGame: 'Discover more exciting things >',
    acquired: 'ទទួលបាន',
    outOfScope: 'ទីតាំងបច្ចុប្បន្នរបស់អ្នកគឺនៅក្រៅជួរសកម្ម',
    switchPositioning: 'ផ្លាស់ប្តូរទីតាំងដើម្បីទទួលបានព័ត៌មាន',
    cashCoupons:'គូប៉ុងទឹកប្រាក់',
    discountCoupon:'គូប៉ុងបញ្ចុះតម្លៃ',
    minDiscountCoupon:'គូប៉ុងបញ្ចុះតំលៃ',
    openApp: 'បើកកម្មវិធី',
    shareText: 'ខ្ញុំបានរកឃើញខ្លឹមសារដ៏អស្ចារ្យមួយនៅលើវេទិកា WOWNOW ហើយណែនាំវាដល់អ្នក',
    sort: 'តម្រៀប',
    store_rest: 'កំពុងសម្រាក ម៉ោងដំណើរការ៖ {value}',
    resting: 'ម៉ោងសម្រាក',
    delivery_busy_available: 'កំពុងរវល់ · អាចបញ្ជាទិញបន្ទាប់ពី 30 នាទី។',
    delivery_busy: 'រវល់',
    stoped: 'បានបិទ',
    not_in_scope: 'មិនស្ថិតនៅក្នុងបរិវេណនៃការដឹកជញ្ជូន',
    delivery_shipping_fee_reduce: "បញ្ចុះតំលៃដឹកជញ្ជូន",
  },
  enums: {
    sortType: {
      wm_sort_Find_more: 'រើសរើសទាំងអស់',
      wm_sort_Good_rates: 'វាយតម្លៃល្អជាងគេ',
      wm_sort_Best_sell: 'លក់ដាច់បំផុត',
      wm_sort_Nearest: 'ជិតបំផុត'
    },
    flag_new: 'ទំនិញថ្មី',
    hide: 'បីទទុក',
    expand: 'បើកមើល',
  },
  cmsCoupon: {
    deliveryCoupons: 'គូប៉ុងដឹកជញ្ជូន',
    notThreshold: "មិនកំណត់",
    hasThreshold: "គ្រប់ {money}អាចប្រើបាន",
    notStart: 'ព្រឹត្តិការណ៍មិនទាន់ចាប់ផ្តើម។',
    endAct: "ព្រឹត្តិការណ៍បានបញ្ចប់",
    amountHasOut: 'Amount Has Out',
    goToUse: "ប្រើប្រាស់",
    successToast: 'បានទទួលជោគជ័យ',
    clickToRedeem: "ចុចដើម្បីប្តូរយក​"
  },
  cmsSuperCoupon: {
    csuper_pageTitle: "WOWcoupons",
    csuper_coupon: "WOWcoupons",
    discount: "បញ្ចុះតម្លៃ {value} %",
    purchase_history: 'ប្រវត្តិនៃការបញ្ជាទិញ',
    delivery_up_to_off: 'បញ្ចុះតម្លៃរហូតដល់ {money}',
    can_expand_up_to: 'WOWMEGA បញ្ចុះរហូតដល់ {money}',
    purchasing: 'បញ្ជាទិញ',
    delivery_piece: 'ដុំ',
    group_on_score_empty: "មិនទាន់មានចំណាត់ថ្នាក់នៅឡើយទេ",
  }
}
